export default __webpack_public_path__ + "static/media/scoopB.203c83ca.png";